var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AuthBasedGuard } from './auth-based-guard';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
var CanActivateViaAuthGuard = /** @class */ (function (_super) {
    __extends(CanActivateViaAuthGuard, _super);
    function CanActivateViaAuthGuard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get user from the store or fetch it from the API and check if is logged to authorize the route
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<boolean> | Promise<boolean> | boolean}
     */
    CanActivateViaAuthGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        if (this.isLogged) {
            return true;
        }
        else {
            return this.authService.getCurrentUser().map(function (user) {
                if (user && user.id > 0) {
                    _this.userActions.loginUser(user);
                    _this.userService.keepSessionAlive();
                    _this.angulartics2GoogleAnalytics.setUsername(user.login);
                    return true;
                }
                else {
                    _this.authService.redirectUrl = state.url;
                    _this.router.navigate(['/login']);
                    return false;
                }
            }).catch(function () {
                _this.authService.redirectUrl = state.url;
                _this.router.navigate(['/login']);
                return Observable.of(false);
            });
        }
    };
    return CanActivateViaAuthGuard;
}(AuthBasedGuard));
export { CanActivateViaAuthGuard };



// WEBPACK FOOTER //
// ./src/app/routing/auth-guard.ts.pre-build-optimizer.js